import React, { CSSProperties } from 'react';
import { Button, Menu, MenuItem, useTheme } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import _ from 'lodash';
import { useAppLang } from '../../providers/AppLangProvider';
import useAppLangs from '../../hooks/useAppLangs';

type AppLangSelectProps = {
	style?: CSSProperties;
};

const AppLangSelect = (props: AppLangSelectProps) => {
	const appLang = useAppLang();
	const theme = useTheme();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelect = (lang: string) => {
		setAnchorEl(null);
		appLang.changeLanguage(lang);
	};

	const styles = {
		menu: {
			...props.style,
			fontSize: '1rem',
		},
		menu_item: {
			color: theme.palette.mode === 'dark' ? '#FFF' : '',
		},
	};

	const appLangs = useAppLangs();

	return (
		<div>
			<Button
				onClick={handleClick}
				endIcon={<ExpandMore sx={{ margin: 0 }} />}
				sx={{ ...styles.menu, '& .MuiButton-endIcon': { margin: '0px' } }}
			>
				{appLang.language === 'fr' ? 'FR' : 'EN'}
			</Button>
			<Menu
				sx={styles.menu}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				{_.sortBy(
					appLangs.filter((x) => x.display),
					['position'],
					['asc'],
				).map((lang) => {
					return (
						<MenuItem key={lang.tag} onClick={() => handleSelect(lang.code_iso2)} sx={styles.menu_item}>
							{lang.name_short}
						</MenuItem>
					);
				})}
			</Menu>
		</div>
	);
};

export default AppLangSelect;
